import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { matchPath } from "react-router-dom";

function hidePadding(url: string): boolean {
  return (
    !!matchPath("/stores/:storeId/redo-concierge/playbook", url) ||
    !!matchPath("/stores/:storeId/redo-concierge/calendar", url) ||
    !!matchPath("/stores/:storeId/redo-concierge/conversations", url) ||
    !!matchPath("/stores/:storeId/redo-concierge/knowledge", url) ||
    !!matchPath("/stores/:storeId/redo-concierge/settings", url)
  );
}

export const shopperAgentRoutes: PermissionedRouteObject[] = [
  {
    handle: { breadcrumb: "Concierge" },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page hidePadding={hidePadding} newChrome /> };
    },
    children: [
      {
        async lazy() {
          const { ConciergeAskRedoRouteContext } = await import(
            "../../../concierge/concierge-ask-redo-route-context"
          );
          return { Component: ConciergeAskRedoRouteContext };
        },
        children: [
          {
            handle: { breadcrumb: "Dashboard" },
            index: true,
            async lazy() {
              const { ConciergeIndexPage } = await import(
                "../../../concierge/concierge-index-page"
              );
              return { Component: ConciergeIndexPage };
            },
          },
          {
            path: "conversations",
            handle: { breadcrumb: "Conversations" },
            async lazy() {
              const { ConciergeConversationsPageSwitcher } = await import(
                "../../../concierge/conversations/v2/concierge-conversations-page-switcher"
              );
              return { Component: ConciergeConversationsPageSwitcher };
            },
          },
          {
            path: "analytics",
            handle: { breadcrumb: "Analytics" },
            async lazy() {
              const { ConciergeAnalyticsPageSwitcher } = await import(
                "../../../concierge/conversations/v2/concierge-analytics-page-switcher"
              );
              return { Component: ConciergeAnalyticsPageSwitcher };
            },
          },
          {
            path: "calendar",
            handle: { breadcrumb: "Calendar" },
            async lazy() {
              const { ConciergeCalendarPage } = await import(
                "../../../concierge/calendar/concierge-calendar-page"
              );
              return { Component: ConciergeCalendarPage };
            },
          },
          {
            path: "sandbox",
            handle: { breadcrumb: "Sandbox" },
            async lazy() {
              const { ConciergeSandboxPage } = await import(
                "../../../concierge/concierge-coming-soon-page"
              );
              return { Component: ConciergeSandboxPage };
            },
          },
          {
            path: "knowledge",
            handle: { breadcrumb: "Knowledge" },
            async lazy() {
              const { ConciergeKnowledgePage } = await import(
                "../../../setting/ai-agent/knowledge/page"
              );
              return { Component: ConciergeKnowledgePage };
            },
          },
          {
            path: "settings",
            handle: { breadcrumb: "Settings" },
            async lazy() {
              const { ConciergeSettingsRoute } = await import(
                "../../../concierge/concierge-settings-route"
              );
              return { Component: ConciergeSettingsRoute };
            },
          },
          {
            path: "playbook",
            handle: { breadcrumb: "Playbook" },
            async lazy() {
              const { ConciergePlaybookRoute } = await import(
                "../../../concierge/concierge-playbook-route"
              );
              return { Component: ConciergePlaybookRoute };
            },
          },
        ],
      },
    ],
  },
];
